/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Notification } from '../../utils/utils';
import { createAction } from '../../utils/redux-utils';
import { DelayedDownloadingsListItemDto, FileInfo } from '../api/downloadings/downloadingsClient.typings';

export enum DownloadingsActionType {
    GET_DELAYED_DOWNLOADINGS_START_ACTION = 'Delayed downloadings/ get files list start action',
    GET_DELAYED_DOWNLOADINGS_SUCCESS_ACTION = 'Delayed downloadings/ get files list success action',
    GET_DELAYED_DOWNLOADINGS_ERROR_ACTION = 'Delayed downloadings/ get files list error action',
    START_DELAYED_DOWNLOADINGS_POLLING_ACTION = 'Delayed downloadings/ start delayed downloadings polling action',
    STOP_DELAYED_DOWNLOADINGS_POLLING_ACTION = 'Delayed downloadings/ stop delayed downloadings polling action',
    POLLING_DELAYED_DOWNLOADINGS_SUCCESS_ACTION = 'Delayed downloadings/ polling files list success action',
    POLLING_DELAYED_DOWNLOADINGS_ERROR_ACTION = 'Delayed downloadings/ polling files list error action',
    DELETE_DELAYED_DOWNLOADINGS_ITEMS_START_ACTION = 'Delayed downloadings/ delete files from the list start action',
    DELETE_DELAYED_DOWNLOADINGS_ITEMS_SUCCESS_ACTION = 'Delayed downloadings/ delete files from the list success action',
    DELETE_DELAYED_DOWNLOADINGS_ITEMS_ERROR_ACTION = 'Delayed downloadings/ delete files from the list error action',
    DOWNLOAD_FILE_FROM_THE_LIST_START_ACTION = 'Delayed downloadings/ download file start action',
    DOWNLOAD_FILE_FROM_THE_LIST_SUCCESS_ACTION = 'Delayed downloadings/ download file success action',
    DOWNLOAD_FILE_FROM_THE_LIST_ERROR_ACTION = 'Delayed downloadings/ download file error action',
}

export const getDelayedDownloadingsStartAction = () =>
    createAction(DownloadingsActionType.GET_DELAYED_DOWNLOADINGS_START_ACTION);

export const getDelayedDownloadingsSuccessAction = (payload: DelayedDownloadingsListItemDto[]) =>
    createAction(DownloadingsActionType.GET_DELAYED_DOWNLOADINGS_SUCCESS_ACTION, payload);

export const getDelayedDownloadingsErrorAction = (notification: Notification) =>
    createAction(DownloadingsActionType.GET_DELAYED_DOWNLOADINGS_ERROR_ACTION, { notification });

export const startDelayedDownloadingsPollingAction = () =>
    createAction(DownloadingsActionType.START_DELAYED_DOWNLOADINGS_POLLING_ACTION);

export const stopDelayedDownloadingsPollingAction = () =>
    createAction(DownloadingsActionType.STOP_DELAYED_DOWNLOADINGS_POLLING_ACTION);

export const pollingDelayedDownloadingsSuccessAction = (payload: DelayedDownloadingsListItemDto[]) =>
    createAction(DownloadingsActionType.POLLING_DELAYED_DOWNLOADINGS_SUCCESS_ACTION, payload);

export const pollingDelayedDownloadingsErrorAction = (notification: Notification) =>
    createAction(DownloadingsActionType.POLLING_DELAYED_DOWNLOADINGS_ERROR_ACTION, { notification });

export const deleteDelayedDownloadingsItemStartAction = (ids: number[]) =>
    createAction(DownloadingsActionType.DELETE_DELAYED_DOWNLOADINGS_ITEMS_START_ACTION, ids);

export const deleteDelayedDownloadingsItemSuccessAction = (notification: Notification) =>
    createAction(DownloadingsActionType.DELETE_DELAYED_DOWNLOADINGS_ITEMS_SUCCESS_ACTION, { notification });

export const deleteDelayedDownloadingsItemErrorAction = (notification: Notification) =>
    createAction(DownloadingsActionType.DELETE_DELAYED_DOWNLOADINGS_ITEMS_ERROR_ACTION, { notification });

export const downloadFileFromTheListStartAction = (file: FileInfo) =>
    createAction(DownloadingsActionType.DOWNLOAD_FILE_FROM_THE_LIST_START_ACTION, file);

export const downloadFileFromTheListSuccessAction = () =>
    createAction(DownloadingsActionType.DOWNLOAD_FILE_FROM_THE_LIST_SUCCESS_ACTION);

export const downloadFileFromTheListErrorAction = (notification: Notification) =>
    createAction(DownloadingsActionType.DOWNLOAD_FILE_FROM_THE_LIST_ERROR_ACTION, { notification });

export type DownloadingsAction =
    | ReturnType<typeof getDelayedDownloadingsStartAction>
    | ReturnType<typeof getDelayedDownloadingsSuccessAction>
    | ReturnType<typeof getDelayedDownloadingsErrorAction>
    | ReturnType<typeof startDelayedDownloadingsPollingAction>
    | ReturnType<typeof stopDelayedDownloadingsPollingAction>
    | ReturnType<typeof pollingDelayedDownloadingsSuccessAction>
    | ReturnType<typeof pollingDelayedDownloadingsErrorAction>
    | ReturnType<typeof deleteDelayedDownloadingsItemStartAction>
    | ReturnType<typeof deleteDelayedDownloadingsItemSuccessAction>
    | ReturnType<typeof deleteDelayedDownloadingsItemErrorAction>
    | ReturnType<typeof downloadFileFromTheListStartAction>
    | ReturnType<typeof downloadFileFromTheListSuccessAction>
    | ReturnType<typeof downloadFileFromTheListErrorAction>;
